import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	StyledBottomCircles,
	StyledCircle,
	StyledContainer,
} from './WeatherWidget.styled';
import { weatherLabels } from './WeatherWidget.model';

const WeatherWidget = () => {
	const weather = useObservable(rage.weather.getWeather());

	return (
		<StyledContainer>
			<Text style={{ fontSize: 14, color: '#ffffff' }}>Los Santos</Text>
			<Text style={{ fontSize: 40, color: '#ffffff', marginTop: 4 }}>
				{weather.degrees > 0 ? `+${weather.degrees}` : weather.degrees}°
			</Text>
			<Text
				style={{
					fontSize: 12,
					fontWeight: 500,
					color: '#ffffff',
					marginTop: 24,
					opacity: 0.75,
				}}
			>
				{weatherLabels[weather.weather]}
			</Text>
			<StyledBottomCircles>
				<StyledCircle $active={false} />
				<StyledCircle $active={true} />
				<StyledCircle $active={false} />
			</StyledBottomCircles>
		</StyledContainer>
	);
};

export { WeatherWidget };
